import React from 'react';
import { GlassCard } from '../components/GlassCard';
import { MOCK_COMPLIANCE } from '../data/mockData';
import { Badge } from '../components/Badge';
import SafeIcon from '../common/SafeIcon';
import { FiCheckCircle, FiXCircle, FiAlertCircle } from 'react-icons/fi';

export const Compliance = () => {
  return (
    <div className="space-y-6 max-w-7xl mx-auto">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Compliance & Policy</h1>
        <p className="text-slate-400 mt-1">Continuous monitoring against established security frameworks.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {MOCK_COMPLIANCE.map((policy, i) => (
          <GlassCard key={policy.id} delay={i * 0.1} className="flex flex-col">
            <div className="flex justify-between items-start mb-4">
              <div>
                <span className="text-xs font-mono text-slate-500 mb-1 block">{policy.framework}</span>
                <h3 className="text-lg font-medium">{policy.name}</h3>
              </div>
              <Badge type={policy.status} />
            </div>

            <div className="mt-auto pt-4">
              <div className="flex justify-between items-end mb-2">
                <span className="text-sm text-slate-400">Coverage</span>
                <span className="font-mono text-sm">{policy.progress}%</span>
              </div>
              <div className="w-full h-2 bg-slate-800 rounded-full overflow-hidden">
                <div 
                  className={`h-full ${
                    policy.status === 'passed' ? 'bg-emerald-500' : 
                    policy.status === 'warning' ? 'bg-yellow-500' : 'bg-red-500'
                  }`}
                  style={{ width: `${policy.progress}%` }}
                />
              </div>
              
              <div className="mt-4 flex items-center gap-2 text-xs text-slate-500">
                {policy.status === 'passed' ? <SafeIcon icon={FiCheckCircle} className="text-emerald-500" /> :
                 policy.status === 'warning' ? <SafeIcon icon={FiAlertCircle} className="text-yellow-500" /> :
                 <SafeIcon icon={FiXCircle} className="text-red-500" />}
                {policy.status === 'passed' ? 'Requirements fully met.' : 'Gaps detected in current posture.'}
              </div>
            </div>
          </GlassCard>
        ))}
      </div>
      
      <GlassCard delay={0.4} className="mt-6">
        <h3 className="text-lg font-medium mb-4">Patch Status Overview</h3>
        <div className="flex flex-col md:flex-row gap-8 items-center">
            <div className="w-full md:w-1/2 space-y-4">
                <div>
                    <div className="flex justify-between text-sm mb-1">
                        <span className="text-slate-300">Critical Updates Pending</span>
                        <span className="text-red-400 font-mono">12</span>
                    </div>
                    <div className="w-full h-1.5 bg-slate-800 rounded-full"><div className="h-full bg-red-500 rounded-full" style={{width: '15%'}}></div></div>
                </div>
                <div>
                    <div className="flex justify-between text-sm mb-1">
                        <span className="text-slate-300">Important Updates Pending</span>
                        <span className="text-orange-400 font-mono">45</span>
                    </div>
                    <div className="w-full h-1.5 bg-slate-800 rounded-full"><div className="h-full bg-orange-500 rounded-full" style={{width: '35%'}}></div></div>
                </div>
                <div>
                    <div className="flex justify-between text-sm mb-1">
                        <span className="text-slate-300">Systems Up to Date</span>
                        <span className="text-emerald-400 font-mono">843</span>
                    </div>
                    <div className="w-full h-1.5 bg-slate-800 rounded-full"><div className="h-full bg-emerald-500 rounded-full" style={{width: '85%'}}></div></div>
                </div>
            </div>
            <div className="w-full md:w-1/2 bg-black/30 p-4 rounded-lg border border-white/5">
                <p className="text-sm text-slate-400 leading-relaxed">
                    Note: CyberLoom monitors patch levels via agentless scanning. We do not automatically apply patches or guarantee protection against unpatched vulnerabilities. Please coordinate with your IT operations team for remediation.
                </p>
            </div>
        </div>
      </GlassCard>
    </div>
  );
};